import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadCountries: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.COUNTRIES_ACTIONS.REQUESTED),
    switchMap(() =>
      regionApi.getCountries().pipe(
        switchMap(({ countries }) => of(actions.countriesSucceeded(countries))),
        catchError(error => of(actions.countriesFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Countries/services/epics/loadCountries.ts